export enum Routing {
  SIGN_IN = '/sign-in',
  CONCEPTS_BOARDS = '/concepts',
  CONCEPTS_BOARD = '/concepts/:board',
  CONCEPTS_BOARD_IMAGE_CROP = '/concepts/:board/image/:image'
}

export interface RoutingState {
  [Routing.CONCEPTS_BOARD]: {
    cropped: boolean;
  };
}
